<template>
  <div>    
      <div class="row">
        <div class="col-md-12" style="margin-top: -40px;">
            <graficodoughnut :rotulo="'DETALHES:'"
                                :legendas="legendasmeta"
                                :dados="dadosmeta"
            ></graficodoughnut>
        </div>
        <!-- <div class="col-md-12">
            <ul style="padding-left: 0px; margin-bottom: 0px; margin-top: -40px; height: 61px; overflow:auto;">
                <li v-for="(item, indice) in dadosmeta" :key="indice" class="li-item-card-dash" style="height: 15px;">
                    <span class="txt-item-card-dash-grafico">{{item.name }}</span>
                    <span class="txt-item-card-dash-grafico" style="float: right;">{{ mtdformatavalordecimal(parseFloat(item.value)) }} ({{ mtdformatavalordecimal(parseFloat(item.value) / parseFloat(item.totalgeralvendas) * 100, '') }}%)
                    </span>
                </li>
            </ul>                                            
        </div> -->
      </div>
    </div>
</template>

<script>
import { computed } from 'vue';
import util from '../../utilitarios/util';
import GraficoDoughnut from '../../components/cmpgraficodoughnut.vue';
import Skeletondashboard from '../../components/cmpskeletondashboard2.vue';
export default {
  name: "metafilial",

  components:{
    'graficodoughnut'       : GraficoDoughnut,
    'dashboard_skeleton'   : Skeletondashboard
  },

  data : function name(params) {
    return {
        legendasmeta : [],
       
        margemlucrogeral        : 0,
        showpopover             : false,
        isloading               : false,  
        vtotalservicos          : 0,
        mediafaturamento        : 0,
        usuariologado           : this.$store.state.usuario,

        dadosmeta        : []
        

    }
   
  },
  props: [
     'utodasfiliais',
     'idfilialmeta',
     'pdtini',
     'pdtfim',
     'lstfiliais',
    
  ],
  methods:{
        hidepopover(){
          setTimeout(() => {
                    this.showpopover = false;
                }, 200); 
          
        },
        mtdformatavalordecimal(valor){
				  return util.formatarvalor(valor, '');
        },
        mtdmediafaturados(){
            let mediafat = 0;

            if(this.lstresumopedidos){
                mediafat = this.lstresumopedidos.totalfaturado / this.lstresumopedidos.qf;
            }
            return mediafat;
        }, 
        mtdmargemlucrogeral() {
          var vself               = this;
      
          const ptotalaberto		  = vself.lstresumopedidos.totalaberto;
          const ptotalfaturado	  = vself.lstresumopedidos.totalfaturado;
          const ptotalcusto 		  = vself.lstresumopedidos.totalcusto;
                
          let totalgeral          = ptotalaberto + ptotalfaturado;

          let dif                 = (parseFloat(totalgeral) - parseFloat(ptotalcusto))

          vself.margemlucrogeral  = 0;
          vself.margemlucrogeral  = dif / totalgeral * 100;
          
        },
        mtdexecutadash(){
            var vself           = this;   
            vself.$emit('handlerLoader', true);          
            let filtro          = '';
            let filtrorecebimento          = '';
            let periodo         = '"' + util.InverterData(this.pdtini) + ' 00:00:00" and "' + util.InverterData(this.pdtfim) + ' 23:59:59"';
            if (vself.lstfiliais.length > 0) {
                let stringfilial = vself.lstfiliais.join(',');
                filtro  = ' and mf.idfilial in (' + stringfilial + ')';
            }        
            if (vself.lstfiliais.length > 0) {
                let stringfilial = vself.lstfiliais.join(',');
                filtrorecebimento  =  ' and pc.idfilial in (' + stringfilial + ')';
            }
            // let filtro          = vself.mtdfiltropesquisa();
            // let filtrocp        = vself.mtdfiltropesquisacp();
            let parametros      = [
                {parametro: 'idclientesac', valor  : window.localStorage.getItem('idcliente')},
                {parametro: 'op',           valor  : 'dashboard'},
                {parametro: 'periodo',      valor : periodo},
                {parametro: 'filiais',      valor : JSON.stringify(vself.lstfiliais)},
                {parametro: 'filtro',       valor  : filtro},
                {parametro: 'filtror',       valor  : filtrorecebimento},
                // {parametro: 'filtrocp',     valor  : filtrocp},
                // {parametro: 'dini',         valor  : util.InverterData(vself.pdtini)},
                // {parametro: 'dfim',         valor  : util.InverterData(vself.pdtfim)}
            ];
            let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidoscompra.php');
            retorno.then(function (response) {
                

                // vself.dadossetorpro     = response.data.setorpro;
                // vself.legendassetorpro  = util.gerardadoslegendagrafico(vself.dadossetorpro);

                // vself.dadosgrupospro    = response.data.grupopro;
                // vself.legendasgrupospro = util.gerardadoslegendagrafico(vself.dadosgrupospro);

                // vself.dadospedidosfil   = response.data.comprasfil;
                // vself.legendaspedidofil = util.gerardadoslegendagrafico(vself.dadospedidosfil);

                // vself.dadosmarca        = response.data.comprasmarca;
                // vself.legendasmarca     = util.gerardadoslegendagrafico(vself.dadosmarca);

        
                vself.dadosmeta = [
                    {value: parseFloat(response.data.atingida), name: 'ATINGIDA'},
                    {value: parseFloat(response.data.restante), name: 'RESTANTE'}                       
                    
                ];
                vself.legendasmeta = util.gerardadoslegendagrafico(vself.legendasmeta);

                // vself.mtdprocessadadosgraficoline(response.data.prevrecebimento);
                // vself.mtdprocessadadosgraficolinepag(response.data.prevpagamento);
                // vself.mtdprocessadadosgraficolinecontas(response.data.contaspagar)
                vself.$emit('handlerLoader', false);
            }).catch(function (response) {
                vself.$emit('handlerLoader', false);
            });
        },
  },
  mounted(){


    setTimeout(() => {
         this.mtdexecutadash();
    }, 3000);
   
  },
  computed:{
            
  },
}
</script>
